'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'palette';
var width = 512;
var height = 512;
var aliases = [127912];
var unicode = 'f53f';
var svgPathData = ['M32 256c0 119.4 93.4 217 211.1 223.6l32.4-32.4c-12.6-17.1-19.5-37.8-19.5-59.3 0-55.2 44.7-99.9 99.9-99.9l124.1 0 0-32C480 132.3 379.7 32 256 32S32 132.3 32 256zm120 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm32-96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm96-32a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm96 32a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z', 'M480 288l0-32C480 132.3 379.7 32 256 32S32 132.3 32 256c0 119.4 93.4 217 211.1 223.6l32.4-32.4c-12.6-17.1-19.5-37.8-19.5-59.3 0-55.2 44.7-99.9 99.9-99.9L480 288zM307.9 435.9L320 448 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0 512 114.6 512 256l0 64-156.1 0c-37.5 0-67.9 30.4-67.9 67.9 0 18 7.2 35.3 19.9 48zM104 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm56-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72-8a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120 8a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPalette = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;